import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AdminAuthService } from '../../services/admin-auth/admin-auth.service';

export const superUserGuard: CanActivateFn = () => {
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);

  return adminAuth
    .check()
    .pipe(
      map((isAdmin) =>
        isAdmin
          ? true
          : router.createUrlTree([
              '/error',
              'No cuentas con permisos de administrador para acceder a esta sección.'
            ])
      )
    );
};
